/**
 * Header: logo + "PGH BITES / LEAVE A REVIEW" + 🖤💛.
 * The logo uses /logo.svg if a small optimized version is present; otherwise a crisp gold-ring
 * "PB" mark (the supplied logo.svg is a 3.4 MB raster-embedded file, too heavy for the iframe —
 * see BLOCKERS.md B11).
 */
import { useState } from 'react';

export function Header() {
  const [logoOk, setLogoOk] = useState(true);

  return (
    <header className="app-header">
      <div className="brand-mark" aria-hidden="true">
        {logoOk ? (
          <img src="/logo.svg" alt="" className="brand-logo" onError={() => setLogoOk(false)} />
        ) : (
          <span className="brand-pb">PB</span>
        )}
      </div>
      <div className="brand-text">
        <span className="brand-line-1">PGH BITES</span>
        <span className="brand-line-2">LEAVE A REVIEW</span>
      </div>
      <span className="brand-hearts" aria-label="PGH Bites">🖤💛</span>
    </header>
  );
}
